import { createContext, useContext, useEffect, useState } from 'react';
import {
  fetchLanguage,
  getLanguage,
  getLanguageStorageArea,
  getLanguageStorageKey,
  storeLanguage,
} from '../utils/languageUtils';

const useInitLanguageContext = () => {
  const [language, _setLanguage] = useState(fetchLanguage());

  const setLanguage = (language) => {
    storeLanguage(language);
    _setLanguage(getLanguage(language));
  };

  useEffect(() => {
    const storageEvent = (/*StorageEvent*/ event) => {
      if (event.storageArea === getLanguageStorageArea() && event.key === getLanguageStorageKey()) {
        _setLanguage(getLanguage(event.newValue));
      }
    };
    window.addEventListener('storage', storageEvent);
    return () => {
      window.removeEventListener('storage', storageEvent);
    };
  }, []);

  return { language: language, setLanguage: setLanguage };
};

const LanguageContext = createContext(null);

export const useLanguageContext = () => {
  const value = useContext(LanguageContext);
  if (value == null) throw new Error('LanguageContextProvider not declared above current component.');
  return {
    language: value.language,
    setLanguage: value.setLanguage,
  };
};

export const LanguageContextProvider = ({ children }) => {
  const value = useInitLanguageContext();
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};
